import React, { Component } from 'react';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
// import StarRatingComponent from 'react-star-rating-component';
import cjquery from 'jquery';
import StarRatings from 'react-star-ratings';
import { Col, Row, Tooltip } from 'reactstrap';
import language from '../../../assets/languages/language';
import ModalComponent from '../../Common/Modal';
import Cfa3SubscriptionCheck from '../../RestAPI/Cfa3Subscription';
import PartnerCfa3SubscriptionCheck from '../../RestAPI/PartnerSubscription/Cfa3Subscription';
import AlertMessage from '../../config/alertMessage';
// import GD from '../RestAPI/getData';
// import { getDeviceDetails } from "../../common/deviceDetails";
import { EXAM_NAMES, examNameAccordingToDB } from '../../../common/constant';
import { getIpAddress } from '../../../common/getIpAddress';
import ValidateSaveReportIcon from '../../Common/ValidateSaveReportIcon';
import FlashCard from '../../../components/FlashCard';
import { isRevisionModeActive, renderHTMLContent } from '../../../common/function';
import ViewQuestion from '../../../Components-2025/QuestionBank/ViewQuestion';
import userStore from "../../../store/userStore";

/* eslint-disable*/
class Cfa3chapter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      successAlert: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: AlertMessage.messageContent_cfa_3,
      questions: [],
      all_questions_state: [],
      token: '',
      idname: '',
      ValidToken: false,
      reportLoading: false,
      chapter_id: '',
      offset: 0,
      limit: 1,
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      clicked: false,
      choice: '',
      isFlashCardHidden: true,
      result: '',
      text_color: 'card-header',
      records: '',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      flagCSS: 'fa fa-flag-o mark-action-btn',
      timerstopbtn: 'pause_btn icon-control-play',
      save_text: `${language.LC().SAVE_QUESTION}`,
      savedQuestion: false,
      comment: 'card-block',
      flashcard: 'card-block',
      comment_data: '',
      flash_data: [],
      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
      comment_arrow: '',
      flash_card_arrow: '',
      flash_class: 'edit_right_padding',
      count: 0,
      rating: 0,
      rated: false,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      validated: false,
      comment_update: 'hide_block',
      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
      comment_update_id: '',
      next_block: '',
      previ_block: '',
      question_length: '',
      timer_stop: true,
      timer_tag: 'Start',
      chaptername: '',
      caseid: this.props.params.caseid,
      all_cases: [],
      cases_display: '',
      cases_name: '',
      cases_length: '',
      case_id: '',
      cases_offset: '',
      casesquestion_length: '',
      chapters: '',
      display_loader: '',
      selectedmenu: 'cfa_3',
      subscriptionstatus: '',
      display_subcription: 'hide_block',
      display_cases: 'show_block',

      showCompletionQuestion: false,
      markAsCompleted: false,
      markAsNotCompleted: false,
      markCompleted: true,
      cases: [],
      exam_type: 'cfa3',

      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      forumComment: '',
      category: 'CFA Level 3',
      tags: ['cfa-3', 'cfa', 'question', 'case'],
      tooltips: [
        {
          placement: `${language.LC().COMMENT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().REPORT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().FLASHCARD_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
      ],
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
      selectedChoice: null,
      timeDone: 0,
    };
    this.childRef = null;
    this.setChildRef = element => {
      this.childRef = element;
    };
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  saveForumComment(e) {
    this.setState({ forumComment: e.target.value });
  }

  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }
  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }


  _tick() {
    if (!this.state.timer_stop) {
      this.setState(prevState => ({
        count: prevState.count + 1
      }));
    }
  }


  timerFunction = (item, e) => {
    if (this.state.timer_stop) {
      this.setState({
        timer_stop: false,
        timer_tag: 'Stop',
        timerstopbtn: 'pause_btn icon-control-pause'
      }, () => {
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.timer = setInterval(this._tick.bind(this), 1000);
      });
    } else {
      this.setState({
        timer_stop: true,
        timer_tag: 'Start',
        timerstopbtn: 'pause_btn icon-control-play'
      });
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  };

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  _getReadings = () => {
    this.context.router.push({
      pathname: `/cfa3/cases/${this.state.chapters.id}/${this.state.chapters.chapter_name}/${this.state.chapters.total_cases
        }`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        chapter: this.state.chapters,
      },
    });
  };

  _getAnswer = (choice, e) => {
    const currentQuestionId = this.state.questions.id;
    const selectedChoice = choice[0];

    this.setState({
      selectedChoice: selectedChoice,
      setAnswer: true,
      clicked: false,
      showAnswer: false,
      stopTimer: false,
      choice_a: selectedChoice === 'choice_a' ? 'answer_box clicked_box' : 'answer_box',
      choice_b: selectedChoice === 'choice_b' ? 'answer_box clicked_box' : 'answer_box',
      choice_c: selectedChoice === 'choice_c' ? 'answer_box clicked_box' : 'answer_box',
      choice_d: selectedChoice === 'choice_d' ? 'answer_box clicked_box' : 'answer_box',
      choice_e: selectedChoice === 'choice_e' ? 'answer_box clicked_box' : 'answer_box'
    }, () => {
      const currentAttempts = this.state.attemptedQuestions || {};
      const updatedAttempts = {
        ...currentAttempts,
        [currentQuestionId]: {
          selectedChoice: this.state.selectedChoice,
          isAnswered: false,
          setAnswer: true
        }
      };

      this.setState({ attemptedQuestions: updatedAttempts });
    });

    var data = {
      token: this.state.token,
      idname: this.state.idname,
      id: this.props.params.id,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };
    FD.callAPI(App_data.backend_api + '/cfa_3question_bank/trackUserRecord', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
      }
    });
  };

  changeCompletionStatus(e) {
    e.preventDefault();
    if (this.state.markAsCompleted == true) {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        case_no: this.state.cases.casesingleData.case_number,
        completion_status: this.state.markAsCompleted,
        exam_type: this.state.exam_type,
        chapter_id: this.props.params.chapterid,
      };
      FD.callAPI(App_data.backend_api + '/cfa_3question_bank/updateCases', data).then(resp => {
        if (resp.success) {
          this._getReadings();
        }
      });
    } else {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        case_no: this.state.cases.casesingleData.case_number,
        completion_status: this.state.markAsCompleted,
        exam_type: this.state.exam_type,
        chapter_id: this.props.params.chapterid,
      };
      FD.callAPI(App_data.backend_api + '/cfa_3question_bank/updateCases', data).then(resp => {
        if (resp.success) {
          this._getReadings();
        }
      });
    }
  }

  markCompleted() {
    this.setState({
      markAsCompleted: true,
      markAsNotCompleted: false,
      markCompleted: false,
    });
  }

  markNotCompleted() {
    this.setState({
      markAsCompleted: false,
      markAsNotCompleted: true,
      markCompleted: false,
    });
  }

  _getResult = (item, e) => {
    if (this.state.selectedChoice) {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      const currentQuestionId = item.id;

      const correctChoiceKey = item['answer'];
      const isCorrect = this.state.selectedChoice === `choice_${correctChoiceKey}`;

      const timeDone = item["cfa3_question_stats.time_done"] || this.state.count;

      this.setState({
        timer_stop: true,
        timer_tag: 'Start',
        timerstopbtn: 'pause_btn icon-control-play',
        setAnswer: true,
        clicked: true,
        showAnswer: true,
        stopTimer: true,
        result_block: 'card show_block',
        result: isCorrect ? 'CORRECT' : 'INCORRECT',
        text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure'
      }, () => {
        const currentAttempts = this.state.attemptedQuestions || {};
        const updatedAttempts = {
          ...currentAttempts,
          [currentQuestionId]: {
            selectedChoice: this.state.selectedChoice,
            isAnswered: true,
            isCorrect: isCorrect,
            setAnswer: true,
            timeSpent: timeDone
          }
        };

        this.setState({ attemptedQuestions: updatedAttempts });

        if (isCorrect) {
          if (this.state.selectedChoice === 'choice_a') {
            this.setState({ choice_a: 'answer_box success' });
          } else if (this.state.selectedChoice === 'choice_b') {
            this.setState({ choice_b: 'answer_box success' });
          } else if (this.state.selectedChoice === 'choice_c') {
            this.setState({ choice_c: 'answer_box success' });
          } else if (this.state.selectedChoice === 'choice_d') {
            this.setState({ choice_d: 'answer_box success' });
          } else if (this.state.selectedChoice === 'choice_e') {
            this.setState({ choice_e: 'answer_box success' });
          }
        } else {
          if (this.state.selectedChoice === 'choice_a') {
            this.setState({ choice_a: 'answer_box failure' });
          } else if (this.state.selectedChoice === 'choice_b') {
            this.setState({ choice_b: 'answer_box failure' });
          } else if (this.state.selectedChoice === 'choice_c') {
            this.setState({ choice_c: 'answer_box failure' });
          } else if (this.state.selectedChoice === 'choice_d') {
            this.setState({ choice_d: 'answer_box failure' });
          } else if (this.state.selectedChoice === 'choice_e') {
            this.setState({ choice_e: 'answer_box failure' });
          }

          if (item.right_choice === 'choice_a') {
            this.setState({ choice_a: 'answer_box success' });
          } else if (item.right_choice === 'choice_b') {
            this.setState({ choice_b: 'answer_box success' });
          } else if (item.right_choice === 'choice_c') {
            this.setState({ choice_c: 'answer_box success' });
          } else if (item.right_choice === 'choice_d') {
            this.setState({ choice_d: 'answer_box success' });
          } else if (item.right_choice === 'choice_e') {
            this.setState({ choice_e: 'answer_box success' });
          }
        }
      });

      if (!this.state.validated) {
        var data = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.id,
          right_answer: isCorrect ? 1 : 0,
          time_done: timeDone,
          selected_choice: this.state.selectedChoice,
        };

        FD.callAPI(App_data.backend_api + '/cfa_3question_bank/saveStats', data).then(resp => {
          if (resp.success) {
            this.setState({ ValidToken: true, validated: true });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        });
      }
    } else {
      this.setState({
        result_block: 'card hide_block'
      });
    }
  };


  _saveQuestion = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      chapter_id: this.props.params.chapterid,
    };
    if (this.state.bookmarkCSS == 'fa fa-bookmark mark-action-btn-bookmark') {

      FD.callAPI(App_data.backend_api + '/cfa_3question_bank/unsaveQuestion', data).then(resp => {
        if (resp.success) {
          if (this.childRef) {
            this.childRef.deleteFlash();
          }
          this.setState({
            ValidToken: true,
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
            bookmarkColor: '',
            save_text: `${language.LC().SAVE_QUESTION}`,
            isFlashCardHidden: true,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    } else {
      FD.callAPI(App_data.backend_api + '/cfa_3question_bank/saveQuestion', data).then(resp => {
        if (resp.success) {
          this.setState({ ValidToken: true, isFlashCardHidden: false });
          this.setState({
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
          });
          this.setState({
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
          });
          this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
          this.setState({ save_text: `${language.LC().Question_Saved}` });
        } else {
          this.setState({ ValidToken: false, isFlashCardHidden: true });
        }
        return resp;
      });
    }
  };

  onStarClick(item, nextValue, prevValue, name) {
    if (prevValue !== nextValue);
    {
      var params = {
        token: this.state.token,
        idname: this.state.idname,
        question_id: item.id,
        ratting: nextValue,
      };
      FD.callAPI(App_data.backend_api + '/cfa_3question_bank/UpdateCfaRatting', params).then(
        response => {
          if (response.success) {
            this.setState({ rated: 1 });
            this.setState({ ratting_text: 'Rated ' });
          }
        },
      );
    }

    this.setState({ rating: nextValue });
    var params = {
      token: this.state.token,
      question_id: item.id,
      idname: this.state.idname,
    };
    FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getCfaratting', params).then(
      response => {
        if (response.success) {
          if (response.ratting.length > 0) {
            this.setState({ rated: true });
            response.ratting.map(items => {
              this.setState({ rating: items.ratting });
              this.setState({ ratting_text: 'Rated ' });
            });
          } else {
            var params = {
              token: this.state.token,
              idname: this.state.idname,
              question_id: item.id,
              ratting: nextValue,
            };
            FD.callAPI(App_data.backend_api + '/cfa_3question_bank/saveCfaratting', params).then(
              response => {
                if (response.success) {
                  this.setState({ rated: 1 });
                  this.setState({ ratting_text: 'Rated ' });
                }
              },
            );
          }
        } else {
          var params = {
            token: this.state.token,
            idname: this.state.idname,
            question_id: item.id,
            ratting: nextValue,
          };
          FD.callAPI(App_data.backend_api + '/cfa_3question_bank/saveCfaratting', params).then(
            response => {
              if (response.success) {
                this.setState({ rated: 1 });
                this.setState({
                  ratting_text: 'Rated ' + nextValue + ' ' + 'stars',
                });
              }
            },
          );
        }
      },
    );
  }

  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };

  _reportQuestion = (item, e) => {
    var comment = document.getElementById('comment').value;
    if (comment.length < 2) {
      return;
    }
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      comment: comment,
      caseIndex: this.props.params.case_offset,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };
    this.setState({
      reportLoading: true,
    });
    FD.callAPI(App_data.backend_api + '/cfa_3question_bank/reportQuestion', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          successAlert: true,
          reportLoading: false,
        });
        document.getElementById('comment').value = '';
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };

  onClose = e => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };

  _hideReportForm = (item, e) => {
    this.setState({ report_block: 'card hide_block' });
  };


  _getToggleComment = (item, e) => {
    cjquery(this.refs['comment_toggle_div']).slideToggle(1000);
  };


  _getToggleFlash = (item, e) => {
    cjquery(this.refs['flash_toggle_div']).slideToggle(1000);
  };


  _saveFlashCard = (item, e) => {
    if (document.getElementById('flash_card').value == '') {
      return;
    }

    var flash_card = document.getElementById('flash_card').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      flash_card: flash_card,
    };
    FD.callAPI(App_data.backend_api + '/cfa_3question_bank/saveFlashCard', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('flash_card').value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.id,
        };
        FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getFlashCards', params).then(
          response => {
            var flash_cards = '';
            if (response.success) {
              this.setState({ ValidToken: true });

              if (response.flash_cards.length > 0) {
                this.setState({
                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
                });
                flash_cards = response.flash_cards.map((items, index) => (
                  <li key={index}>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({
                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                });
                flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              }
              this.setState({ flash_data: flash_cards });
            } else {
              flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({ ValidToken: false });
              this.setState({ flash_data: flash_cards });
              this.setState({
                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
              });
            }
            return response;
          },
        );
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  _editFlash = (item, e) => {
    this.setState({
      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
    });
    document.getElementById('flash_card').value = item.flash_card;
  };

  _deleteFlash = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      flash_card: item,
    };
    FD.callAPI(App_data.backend_api + '/cfa_3question_bank/deleteFlashCard', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        this.setState({
          flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
        });
        document.getElementById('flash_card').value = '';
        var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
        this.setState({ flash_data: flash_cards });
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  async componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      token: storage_session['token'],
      idname: storage_session['idname'],
    });
    window.scrollTo(0, 0);
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }

    this.setState({
      case_id: this.props.params.caseid,
      display_cases: 'hide_block',
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
      var data = {
        token: storage_session['token'],
        idname: storage_session['idname'],
        caseid: this.props.params.caseid,
      };
      FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getCasesbyId', data).then(
        resp_cases => {
          this.setState({ cases: resp_cases });
          if (resp_cases.success) {
            var data = {
              token: storage_session['token'],
              idname: storage_session['idname'],
            };
            // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
            userStore.getUserProfile(true).then(resp => {
              var free_status = '';
              if (resp.profileInfo.role === 'partner') {
                if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
                  free_status = 'free';
                  this.setState({ subscriptionstatus: 'free' });
                  if (resp_cases.casesingleData.free === 0) {
                    this.setState({
                      display_cases: 'hide_block',
                      display_subcription: 'show_block',
                    });
                    this.toggleAlert();
                  } else {
                    this.setState({
                      display_cases: 'show_block',
                      display_subcription: 'hide_block',
                    });
                  }
                } else {
                  this.setState({
                    cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
                    cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
                  });
                  var data_arr = resp.profileInfo.exam_selected
                    ? JSON.parse(resp.profileInfo.exam_selected)
                    : null;
                  var dataset = {
                    token: storage_session['token'],
                    idname: storage_session['idname'],
                    examid: data_arr,
                  };
                  FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
                    async resp_exam => {
                      if (resp_exam.success) {
                        var exam_data = resp_exam.examData;
                        var selectedmen = this.state.selectedmenu;
                        var isInArray_var = false;
                        const examPlanData = resp_exam.examPlan[0];
                        isInArray_var = await PartnerCfa3SubscriptionCheck.checkCfa3Subscription(
                          selectedmen,
                          exam_data,
                          this.state.cfaUnlimitedPackage,
                          this.state.cfaUnlimitedActiveExam,
                          examPlanData,
                        );
                        if (isInArray_var) {
                          this.setState({
                            subscriptionstatus: 'paid',
                            display_cases: 'show_block',
                            display_subcription: 'hide_block',
                          });
                        } else {
                          if (resp_cases.casesingleData.free == 0) {
                            this.setState({
                              display_cases: 'hide_block',
                              display_subcription: 'show_block',
                            });
                          } else {
                            this.setState({
                              subscriptionstatus: 'free',
                              display_cases: 'show_block',
                              display_subcription: 'hide_block',
                            });
                          }
                        }
                      }
                    },
                  );
                }
              } else {
                if (
                  resp.profileInfo.exam_selected == '' &&
                  resp.profileInfo.cfaUnlimitedPackage == '' &&
                  resp.profileInfo.cfaUnlimitedActiveExam == ''
                ) {
                  free_status = 'free';
                  this.setState({ subscriptionstatus: 'free' });
                  if (resp_cases.casesingleData.free === 0) {
                    this.setState({
                      display_cases: 'hide_block',
                      display_subcription: 'show_block',
                    });
                    this.toggleAlert();
                  } else {
                    this.setState({
                      display_cases: 'show_block',
                      display_subcription: 'hide_block',
                    });
                  }
                } else {
                  this.setState({
                    cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
                    cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
                  });
                  var data_arr = resp.profileInfo.exam_selected
                    ? JSON.parse(resp.profileInfo.exam_selected)
                    : null;
                  var dataset = {
                    token: storage_session['token'],
                    idname: storage_session['idname'],
                    examid: data_arr,
                  };
                  FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
                    resp_exam => {
                      if (resp_exam.success) {
                        var exam_data = resp_exam.examData;
                        var selectedmen = this.state.selectedmenu;
                        var isInArray_var = false;
                        isInArray_var = Cfa3SubscriptionCheck.checkCfa3Subscription(
                          selectedmen,
                          exam_data,
                          this.state.cfaUnlimitedPackage,
                          this.state.cfaUnlimitedActiveExam,
                        );
                        if (isInArray_var) {
                          this.setState({
                            subscriptionstatus: 'paid',
                            display_cases: 'show_block',
                            display_subcription: 'hide_block',
                          });
                        } else {
                          if (resp_cases.casesingleData.free == 0) {
                            this.setState({
                              display_cases: 'hide_block',
                              display_subcription: 'show_block',
                            });
                          } else {
                            this.setState({
                              subscriptionstatus: 'free',
                              display_cases: 'show_block',
                              display_subcription: 'hide_block',
                            });
                          }
                        }
                      }
                    },
                  );
                }
              }
            });
          }
        },
      );
    // });

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      chapter_id: this.props.params.chapterid,
    };
    FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getChaptersbyID', data).then(resp => {
      if (resp.success) {
        this.setState({ chaptername: resp.chapterdata.chapter_name });
        this.setState({ chapters: resp.chapterdata });
      } else {
        this.setState({ ValidToken: false });
      }
    });
    FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getCases', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        this.setState({ all_cases: resp.readings });
        this.setState({ cases_length: resp.readings.length });

        for (var i = 0; i < resp.readings.length; i++) {
          if (this.props.params.case_offset == i) {
            this.setState({ cases_offset: this.props.params.case_offset });
            this.setState({ cases_display: resp.readings[i].case });
            this.setState({ cases_name: resp.readings[i].case_name });
          }
        }
        var param = {
          token: storage_session['token'],
          idname: storage_session['idname'],
          case_id: this.state.case_id,
        };
        FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getCasesquestion', param).then(
          resp_question => {
            if (resp_question.success) {
              this.setState({
                casesquestion_length: resp_question.questions_details.length,
              });
              // Guard against infinite loader when the BE returns
              // `questions_details: []` — happens when every question row
              // for this case_id has been deactivated by admins
              // (isActive=0) but the parent row in cfa3_2025_cases is
              // still active, so the case tile appears in the chapter
              // list. Without this branch the for-loop below never runs
              // and display_loader stays 'show_block' forever.
              // Also covers the "question_number out of range" case where
              // the URL asks for question 5 but only 3 questions exist.
              if (
                resp_question.questions_details.length === 0 ||
                resp_question.questions_details.length <=
                  this.props.params.question_number - 1
              ) {
                this.setState({
                  display_loader: 'hide_block',
                  all_questions_state: resp_question.questions_details,
                });
                return;
              }
              if (resp_question.questions_details.length > this.props.params.question_number - 1) {
                let offset_res = '';
                var questionid = '';
                for (var i = 0; i < resp_question.questions_details.length; i++) {
                  if (
                    resp_question.questions_details[i].question_number ==
                    this.props.params.question_number
                  ) {
                    offset_res = i;
                    questionid = resp_question.questions_details[i].id;
                    const currentQuestion = resp_question.questions_details[i];
                    const selectedChoice = currentQuestion["cfa3_question_stats.selected_choice"] || '';
                    const rightAnswer = currentQuestion["cfa3_question_stats.right_answer"] || 0;
                    const answerStatus = currentQuestion["cfa3_question_stats.id"] || '';
                    const correctAnswer = `choice_${currentQuestion.answer}`;
                    let showAnswer = false;
                    let selected = '';
                    const isRevisionMode = isRevisionModeActive(EXAM_NAMES.CFA_3);
                    if (selectedChoice && isRevisionMode) {
                      selected = selectedChoice;
                      showAnswer = true;
                    } else if (answerStatus && isRevisionMode) {
                      if (rightAnswer === 1) {
                        selected = correctAnswer;
                        showAnswer = true;
                      } else if (!rightAnswer) {
                        const choices = ['choice_a', 'choice_b', 'choice_c'].filter(choice => choice !== correctAnswer);
                        selected = choices.length > 0 ? choices[0] : '';
                        showAnswer = true;
                      }
                    }
                    if (showAnswer && isRevisionMode) {
                      this.setState({
                        questions: currentQuestion,
                        selectedChoice: selected,
                        clicked: true,
                        choice_a: selected === 'choice_a' ?
                          (selected === correctAnswer ? 'answer_box success' : 'answer_box failure') :
                          (correctAnswer === 'choice_a' ? 'answer_box success' : 'answer_box'),
                        choice_b: selected === 'choice_b' ?
                          (selected === correctAnswer ? 'answer_box success' : 'answer_box failure') :
                          (correctAnswer === 'choice_b' ? 'answer_box success' : 'answer_box'),
                        choice_c: selected === 'choice_c' ?
                          (selected === correctAnswer ? 'answer_box success' : 'answer_box failure') :
                          (correctAnswer === 'choice_c' ? 'answer_box success' : 'answer_box'),
                        result_block: 'card show_block',
                        text_color: selected === correctAnswer ? 'card-header text_success' : 'card-header text_failure',
                        result: selected === correctAnswer ? 'CORRECT' : 'INCORRECT',
                      });
                    } else {
                      this.setState({
                        questions: currentQuestion,
                        selectedChoice: '',
                        clicked: false,
                        choice_a: 'answer_box',
                        choice_b: 'answer_box',
                        choice_c: 'answer_box',
                        result_block: 'card hide_block',
                      });
                    }
                    this.handleTimerResponse(selected);
                  }
                  if (i == resp_question.questions_details.length - 1) {
                    this.setState({ display_loader: 'hide_block' });
                  }
                }
                this.setState({ offset: offset_res });
                this.setState({
                  all_questions_state: resp_question.questions_details,
                });

                var params_fav = {
                  token: storage_session['token'],
                  question_id: questionid,
                  idname: storage_session['idname'],
                  chapter_id: this.props.params.chapterid,
                };
                FD.callAPI(
                  App_data.backend_api + '/cfa_3question_bank/getFavQuestions',
                  params_fav,
                ).then(response => {
                  if (response.success) {
                    this.setState({
                      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                    });
                    this.setState({
                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                    });
                    this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
                    this.setState({
                      save_text: `${language.LC().Question_Saved}`,
                      isFlashCardHidden: false,
                    });
                  } else {
                    this.setState({ isFlashCardHidden: true });
                  }
                });

                var params = {
                  token: storage_session['token'],
                  question_id: questionid,
                  idname: storage_session['idname'],
                };
                FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getCfaratting', params).then(
                  response => {
                    if (response.success) {
                      this.setState({ rated: true });
                      response.ratting.map(items => {
                        this.setState({ rating: items.ratting });
                        this.setState({ ratting_text: 'Rated ' });
                      });
                    }
                  },
                );
                var params = {
                  token: storage_session['token'],
                  idname: storage_session['idname'],
                  question_id: questionid,
                };
                FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getFlashCards', params).then(
                  response => {
                    var flash_cards = '';
                    if (response.success) {
                      this.setState({ ValidToken: true });
                      if (response.flash_cards.length > 0) {
                        this.setState({
                          flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
                        });
                        flash_cards = response.flash_cards.map((items, index) => (
                          <li key={index}>
                            <div className=''>
                              <ul className='icon_list'>
                                <li>
                                  <a
                                    className='pointer_class'
                                    onClick={this._editFlash.bind(this, items)}
                                  >
                                    <i className='fa fa-pencil' />
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className='pointer_class'
                                    onClick={this._deleteFlash.bind(this, items)}
                                  >
                                    <i className='fa fa-close' />
                                  </a>
                                </li>
                              </ul>
                              <div className={this.state.flash_class}>
                                <h4 />
                                <p>{items.flash_card}</p>
                              </div>
                            </div>
                          </li>
                        ));
                      } else {
                        this.setState({
                          flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                        });
                        flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                      }
                      this.setState({ flash_data: flash_cards });
                    } else {
                      flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                      this.setState({ ValidToken: false });
                      this.setState({ flash_data: flash_cards });
                      this.setState({
                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                      });
                    }
                    return response;
                  },
                );

                this.setState({ records: '' });
              }
            } else {
              // BE returned success:false. Same infinite-loader risk as
              // the empty-array case above — kill the loader so the user
              // gets an actionable UI state instead of a hung spinner.
              this.setState({ display_loader: 'hide_block' });
            }
          },
        );
      } else {
        this.setState({ ValidToken: false });
        this.setState({ records: 'Result not found.' });
      }
      clearInterval(this.timer);
      this.timer = setInterval(this._tick.bind(this), 1000);
      return resp;
    });
  }

  _getNext = () => {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    this.setState({ clicked: false });
    if (parseInt(this.state.questions.question_number) === this.state.all_questions_state.length) {
      this.setState({ showCompletionQuestion: true });
    } else {
      this.setState({ display_loader: 'show_block' });
      if (this.props.params.question_number == this.state.casesquestion_length) {
        this.setState({
          validated: false,
          rated: false,
          rating: 0,
          ratting_text: 'Rate this Question',
          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
          save_text: `${language.LC().SAVE_QUESTION}`,
          timerstopbtn: 'pause_btn icon-control-pause',
          report_block: 'card hide_block',
          offset: 0
        });
        document.getElementById('comment').value = '';

        this.context.router.push({
          pathname:
            '/cfa3/chapter/' +
            this.props.params.chapterid +
            '/' +
            this.props.params.caseid +
            '/' +
            this.props.params.case_offset +
            '/' +
            this.state.all_questions_state[0].question_number +
            '/' +
            0,
          state: {
            token: this.state.token,
            idname: this.state.idname,
            chapterid: this.props.params.chapterid,
            caseid: this.props.params.caseid,
            case_offset: this.props.params.case_offset,
            question_number: 0,
            offset: 0,
          },
        });
      } else {
        const i = this.state.offset + 1;
        this.setState({
          validated: false,
          rated: false,
          rating: 0,
          ratting_text: 'Rate this Question',
          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
          save_text: `${language.LC().SAVE_QUESTION}`,
          timerstopbtn: 'pause_btn icon-control-pause',
          report_block: 'card hide_block',
          offset: i
        });
        document.getElementById('comment').value = '';

        this.context.router.push({
          pathname:
            '/cfa3/chapter/' +
            this.props.params.chapterid +
            '/' +
            this.props.params.caseid +
            '/' +
            this.props.params.case_offset +
            '/' +
            this.state.all_questions_state[i].question_number +
            '/' +
            i,
          state: {
            token: this.state.token,
            idname: this.state.idname,
            chapterid: this.props.params.chapterid,
            caseid: this.props.params.caseid,
            case_offset: this.props.params.case_offset,
            question_number: i,
            offset: i,
          },
        });
      }
    }
  };

  _getNextAnyway = () => {
    this.setState({
      display_loader: 'show_block',
      showCompletionQuestion: false,
    });
    this.setState({ clicked: false });
    if (this.props.params.question_number == this.state.casesquestion_length) {
      this.setState({ validated: false });
      this.setState({ rated: false });
      this.setState({ rating: 0 });
      this.setState({ ratting_text: 'Rate this Question' });
      this.setState({
        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      });
      this.setState({
        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      });
      this.setState({ save_text: `${language.LC().SAVE_QUESTION}` });
      this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
      this.setState({ report_block: 'card hide_block' });
      const i = 0;
      this.setState({ offset: i });

      this.context.router.push({
        pathname:
          '/cfa3/chapter/' +
          this.props.params.chapterid +
          '/' +
          this.props.params.caseid +
          '/' +
          this.props.params.case_offset +
          '/' +
          this.state.all_questions_state[i].question_number +
          '/' +
          0,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapterid: this.props.params.chapterid,
          caseid: this.props.params.caseid,
          case_offset: this.props.params.case_offset,
          question_number: i,
          offset: 0,
        },
      });
    } else {
      this.setState({ validated: false });
      this.setState({ rated: false });
      this.setState({ rating: 0 });
      this.setState({ ratting_text: 'Rate this Question' });
      this.setState({
        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      });
      this.setState({
        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      });
      this.setState({ save_text: `${language.LC().SAVE_QUESTION}` });
      this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
      this.setState({ report_block: 'card hide_block' });
      const i = this.state.offset + 1;
      this.setState({ offset: i });
      this.context.router.push({
        pathname:
          '/cfa3/chapter/' +
          this.props.params.chapterid +
          '/' +
          this.props.params.caseid +
          '/' +
          this.props.params.case_offset +
          '/' +
          this.state.all_questions_state[i].question_number +
          '/' +
          i,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapterid: this.props.params.chapterid,
          caseid: this.props.params.caseid,
          case_offset: this.props.params.case_offset,
          question_number: i,
          offset: i,
        },
      });
    }
  };

  _getPrevious = () => {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    const newOffset = this.state.offset === 0 ? this.state.casesquestion_length - 1 : this.state.offset - 1;

    this.setState({
      validated: false,
      rated: false,
      clicked: false,
      rating: 0,
      ratting_text: 'Rate this Question',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      save_text: `${language.LC().SAVE_QUESTION}`,
      timerstopbtn: 'pause_btn icon-control-pause',
      report_block: 'card hide_block',
      offset: newOffset
    });
    document.getElementById('comment').value = '';

    this.context.router.push({
      pathname:
        '/cfa3/chapter/' +
        this.props.params.chapterid +
        '/' +
        this.props.params.caseid +
        '/' +
        this.props.params.case_offset +
        '/' +
        this.state.all_questions_state[newOffset].question_number +
        '/' +
        newOffset,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        chapterid: this.props.params.chapterid,
        caseid: this.props.params.caseid,
        case_offset: this.props.params.case_offset,
        question_number: newOffset,
        offset: newOffset,
      },
    });
  };

  _getNextCase = () => {
    this.setState({ display_cases: 'hide_block' });
    this.setState({ display_subcription: 'hide_block' });
    this.setState({ clicked: false });
    const casesoffset = parseInt(this.state.cases_offset) + 1;
    var caseid = '';
    if (this.state.cases_length > casesoffset) {
      this.setState({ cases_offset: casesoffset });
      caseid = this.state.all_cases[casesoffset].id;
      this.context.router.push({
        pathname:
          '/cfa3/chapter/' +
          this.props.params.chapterid +
          '/' +
          caseid +
          '/' +
          casesoffset +
          '/' +
          '1' +
          '/' +
          0,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapterid: this.props.params.chapterid,
          caseid: caseid,
          case_offset: casesoffset,
          question_number: 1,
          offset: 0,
        },
      });
    } else {
      this.setState({ cases_offset: 0 });
      caseid = this.state.all_cases[0].id;
      this.context.router.push({
        pathname:
          '/cfa3/chapter/' +
          this.props.params.chapterid +
          '/' +
          caseid +
          '/' +
          '0' +
          '/' +
          '1' +
          '/' +
          0,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapterid: this.props.params.chapterid,
          caseid: caseid,
          case_offset: casesoffset,
          question_number: 1,
          offset: 0,
        },
      });
    }
  };

  _getPreviousCase = () => {
    this.setState({ display_cases: 'hide_block' });
    this.setState({ display_subcription: 'hide_block' });
    this.setState({ clicked: false });
    if (this.state.cases_offset == 0) {
      const casesoffset = this.state.cases_length - 1;
      var caseid = this.state.all_cases[casesoffset].id;
      this.setState({ cases_offset: casesoffset });
      this.context.router.push({
        pathname:
          '/cfa3/chapter/' +
          this.props.params.chapterid +
          '/' +
          caseid +
          '/' +
          casesoffset +
          '/' +
          '1' +
          '/' +
          0,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapterid: this.props.params.chapterid,
          caseid: caseid,
          case_offset: casesoffset,
          question_number: 1,
          offset: 0,
        },
      });
    } else {
      const casesoffset = this.state.cases_offset - 1;
      var caseid = this.state.all_cases[casesoffset].id;
      this.setState({ cases_offset: casesoffset });
      this.context.router.push({
        pathname:
          '/cfa3/chapter/' +
          this.props.params.chapterid +
          '/' +
          caseid +
          '/' +
          casesoffset +
          '/' +
          '1' +
          '/' +
          0,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapterid: this.props.params.chapterid,
          caseid: caseid,
          case_offset: casesoffset,
          question_number: 1,
          offset: 0,
        },
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.params.question_number != this.props.params.question_number &&
      nextProps.params.caseid == this.props.params.caseid
    ) {
      this._changeQuestion(
        nextProps.params.chapterid,
        nextProps.params.caseid,
        nextProps.params.case_offset,
        nextProps.params.question_number,
        this.state.token,
        this.state.idname,
        nextProps.params.offset,
      );
      this.setState({ display_loader: 'show_block' });
    }

    if (nextProps.params.caseid != this.props.params.caseid) {
      this._changeCase(
        nextProps.params.chapterid,
        nextProps.params.caseid,
        nextProps.params.case_offset,
        nextProps.params.question_number,
        this.state.token,
        this.state.idname,
        nextProps.params.offset,
      );
      this.setState({ display_loader: 'show_block' });
    }
  }

  /*on url question offset change run this function*/
  _changeQuestion(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
    this.setState({ case_id: caseid });
    var data = { token: token_id, idname: idname, chapter_id: chapterid };

    FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getChaptersbyID', data).then(resp => {
      if (resp.success) {
        this.setState({
          chaptername: resp.chapterdata.chapter_name,
          chapters: resp.chapterdata,
        });
      } else {
        this.setState({ ValidToken: false });
      }
    });

    FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getCases', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          choice_a: 'answer_box',
          choice_b: 'answer_box',
          choice_c: 'answer_box',
          result_block: 'card hide_block',
          rated: false,
          rating: 0,
          ratting_text: 'Rate this Question',
          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
          save_text: `${language.LC().SAVE_QUESTION}`,
          timerstopbtn: 'pause_btn icon-control-pause',
          report_block: 'card hide_block',
          all_cases: resp.readings,
        });

        for (var i = 0; i < resp.readings.length; i++) {
          if (this.props.params.case_offset == i) {
            this.setState({
              cases_display: resp.readings[i].case,
              cases_name: resp.readings[i].case_name,
            });
          }
        }

        this.setState({ display_loader: 'hide_block' });
        var param = { token: token_id, idname: idname, case_id: caseid };

        FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getCasesquestion', param).then(resp_question => {
          if (resp_question.success) {
            this.setState({
              casesquestion_length: resp_question.questions_details.length,
            });

            if (resp_question.questions_details.length > question_number - 1) {
              let offset_res = '';
              var questionid = '';

              for (var i = 0; i < resp_question.questions_details.length; i++) {
                if (resp_question.questions_details[i].question_number == question_number) {
                  offset_res = i;
                  questionid = resp_question.questions_details[i].id;
                  const currentQuestion = resp_question.questions_details[i];
                  const selectedChoice = currentQuestion["cfa3_question_stats.selected_choice"] || '';
                  const rightAnswer = currentQuestion["cfa3_question_stats.right_answer"] || 0;
                  const answerStatus = currentQuestion["cfa3_question_stats.id"] || '';
                  const timeDone = currentQuestion["cfa3_question_stats.time_done"] || 0;
                  const correctAnswer = `choice_${currentQuestion.answer}`;
                  let showAnswer = false;
                  let selected = '';
                  const isRevisionMode = isRevisionModeActive(EXAM_NAMES.CFA_3);
                  if (selectedChoice && isRevisionMode) {
                    selected = selectedChoice;
                    showAnswer = true;
                  } else if (answerStatus && isRevisionMode) {
                    if (rightAnswer === 1) {
                      selected = correctAnswer;
                      showAnswer = true;
                    } else if (!rightAnswer) {
                      const choices = ['choice_a', 'choice_b', 'choice_c'].filter(choice => choice !== correctAnswer);
                      selected = choices.length > 0 ? choices[0] : '';
                      showAnswer = true;
                    }
                  }
                  if (showAnswer && isRevisionMode) {
                    this.setState({
                      questions: currentQuestion,
                      selectedChoice: selected,
                      clicked: true,
                      choice_a: selected === 'choice_a' ?
                        (selected === correctAnswer ? 'answer_box success' : 'answer_box failure') :
                        (correctAnswer === 'choice_a' ? 'answer_box success' : 'answer_box'),
                      choice_b: selected === 'choice_b' ?
                        (selected === correctAnswer ? 'answer_box success' : 'answer_box failure') :
                        (correctAnswer === 'choice_b' ? 'answer_box success' : 'answer_box'),
                      choice_c: selected === 'choice_c' ?
                        (selected === correctAnswer ? 'answer_box success' : 'answer_box failure') :
                        (correctAnswer === 'choice_c' ? 'answer_box success' : 'answer_box'),
                      result_block: 'card show_block',
                      text_color: selected === correctAnswer ? 'card-header text_success' : 'card-header text_failure',
                      result: selected === correctAnswer ? 'CORRECT' : 'INCORRECT',
                    });
                  } else {
                    this.setState({
                      questions: currentQuestion,
                      selectedChoice: '',
                      clicked: false,
                      choice_a: 'answer_box',
                      choice_b: 'answer_box',
                      choice_c: 'answer_box',
                      result_block: 'card hide_block',
                    });
                  }
                  this.handleTimerResponse(selected);
                }
              }

              this.setState({
                offset: offset_res,
                all_questions_state: resp_question.questions_details,
              });
              var params = {
                token: token_id,
                idname: idname,
                question_id: questionid,
              };
              FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getCfaratting', params).then(
                response => {
                  if (response.success) {
                    this.setState({ rated: true });
                    response.ratting.map(items => {
                      this.setState({
                        rating: items.ratting,
                        ratting_text: 'Rated ',
                      });
                    });
                  }
                },
              );
              var params_fav = {
                token: token_id,
                idname: idname,
                question_id: questionid,
                chapter_id: chapterid,
              };

              FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getFavQuestions', params_fav).then(response => {
                if (response.success) {
                  this.setState({
                    save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                    bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                    bookmarkColor: 'rgb(54, 141, 84)',
                    save_text: `${language.LC().Question_Saved}`,
                    isFlashCardHidden: false,
                  });
                } else {
                  this.setState({ isFlashCardHidden: true , bookmarkColor: '',});
                }
              });
            }
          }
        });
      }
    });
  }

  _changeCase(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
    var data = { token: token_id, idname: idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
      var data = {
        token: token_id,
        idname: idname,
        caseid: this.props.params.caseid,
      };
      FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getCasesbyId', data).then(
        resp_cases => {
          if (resp_cases.success) {
            var data = { token: token_id, idname: idname };
            FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
              var free_status = '';

              if (resp.profileInfo.role === 'partner') {
                if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
                  free_status = 'free';
                  this.setState({ subscriptionstatus: 'free' });
                  if (resp_cases.casesingleData.free == 0) {
                    this.setState({
                      display_cases: 'hide_block',
                      display_subcription: 'show_block',
                    });
                    this.toggleAlert();
                  } else {
                    this.setState({
                      display_cases: 'show_block',
                      display_subcription: 'hide_block',
                    });
                  }
                } else {
                  this.setState({
                    cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
                    cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
                  });
                  var data_arr = resp.profileInfo.exam_selected
                    ? JSON.parse(resp.profileInfo.exam_selected)
                    : null;

                  var dataset = {
                    token: token_id,
                    idname: idname,
                    examid: data_arr,
                  };
                  FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
                    async resp_exam => {
                      if (resp_exam.success) {
                        var exam_data = resp_exam.examData;
                        var selectedmen = this.state.selectedmenu;
                        var isInArray_var = false;
                        const examPlanData = resp_exam.examPlan[0];
                        isInArray_var = await PartnerCfa3SubscriptionCheck.checkCfa3Subscription(
                          selectedmen,
                          exam_data,
                          this.state.cfaUnlimitedPackage,
                          this.state.cfaUnlimitedActiveExam,
                          examPlanData,
                        );
                        if (isInArray_var) {
                          this.setState({
                            display_cases: 'show_block',
                            display_subcription: 'hide_block',
                          });
                        } else {
                          if (resp_cases.casesingleData.free == 0) {
                            this.setState({
                              display_cases: 'hide_block',
                              display_subcription: 'show_block',
                            });
                          } else {
                            this.setState({
                              display_cases: 'show_block',
                              display_subcription: 'hide_block',
                            });
                          }
                        }
                      }
                    },
                  );
                }
              } else {
                if (
                  resp.profileInfo.exam_selected == '' &&
                  resp.profileInfo.cfaUnlimitedPackage == '' &&
                  resp.profileInfo.cfaUnlimitedActiveExam == ''
                ) {
                  free_status = 'free';
                  this.setState({ subscriptionstatus: 'free' });
                  if (resp_cases.casesingleData.free == 0) {
                    this.setState({
                      display_cases: 'hide_block',
                      display_subcription: 'show_block',
                    });
                    this.toggleAlert();
                  } else {
                    this.setState({
                      display_cases: 'show_block',
                      display_subcription: 'hide_block',
                    });
                  }
                } else {
                  this.setState({
                    cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
                    cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
                  });
                  var data_arr = resp.profileInfo.exam_selected
                    ? JSON.parse(resp.profileInfo.exam_selected)
                    : null;
                  var dataset = {
                    token: token_id,
                    idname: idname,
                    examid: data_arr,
                  };
                  FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
                    resp_exam => {
                      if (resp_exam.success) {
                        var exam_data = resp_exam.examData;
                        var selectedmen = this.state.selectedmenu;
                        var isInArray_var = false;
                        isInArray_var = Cfa3SubscriptionCheck.checkCfa3Subscription(
                          selectedmen,
                          exam_data,
                          this.state.cfaUnlimitedPackage,
                          this.state.cfaUnlimitedActiveExam,
                        );
                        if (isInArray_var) {
                          this.setState({
                            display_cases: 'show_block',
                            display_subcription: 'hide_block',
                          });
                        } else {
                          if (resp_cases.casesingleData.free == 0) {
                            this.setState({
                              display_cases: 'hide_block',
                              display_subcription: 'show_block',
                            });
                          } else {
                            this.setState({
                              display_cases: 'show_block',
                              display_subcription: 'hide_block',
                            });
                          }
                        }
                      }
                    },
                  );
                }
              }
            });
          }
        },
      );
    });

    this.setState({ case_id: caseid });
    var data = { token: token_id, idname: idname, chapter_id: chapterid };
    FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getChaptersbyID', data).then(resp => {
      if (resp.success) {
        this.setState({
          chaptername: resp.chapterdata.chapter_name,
          chapters: resp.chapterdata,
        });
      } else {
        this.setState({ ValidToken: false });
      }
    });
    FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getCases', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          choice_a: 'answer_box',
          choice_b: 'answer_box',
          choice_c: 'answer_box',
          result_block: 'card hide_block',
          rated: false,
          rating: 0,
          ratting_text: 'Rate this Question',
          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
          save_text: `${language.LC().SAVE_QUESTION}`,
          timerstopbtn: 'pause_btn icon-control-pause',
          report_block: 'card hide_block',
        });
        document.getElementById('comment').value = '';

        this.setState({ all_cases: resp.readings });
        for (var i = 0; i < resp.readings.length; i++) {
          if (this.props.params.case_offset == i) {
            this.setState({
              cases_display: resp.readings[i].case,
              cases_name: resp.readings[i].case_name,
            });
          }
        }
        this.setState({ display_loader: 'hide_block' });
        var param = { token: token_id, idname: idname, case_id: caseid };
        FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getCasesquestion', param).then(
          resp_question => {
            if (resp_question.success) {
              this.setState({
                casesquestion_length: resp_question.questions_details.length,
              });
              if (resp_question.questions_details.length > question_number - 1) {
                let offset_res = '';
                var questionid = '';
                for (var i = 0; i < resp_question.questions_details.length; i++) {
                  if (resp_question.questions_details[i].question_number == question_number) {
                    offset_res = i;
                    questionid = resp_question.questions_details[i].id;
                    const currentQuestion = resp_question.questions_details[i];
                    const selectedChoice = currentQuestion["cfa3_question_stats.selected_choice"] || '';
                    const rightAnswer = currentQuestion["cfa3_question_stats.right_answer"] || 0;
                    const answerStatus = currentQuestion["cfa3_question_stats.id"] || '';
                    const timeDone = currentQuestion["cfa3_question_stats.time_done"] || 0;
                    const correctAnswer = `choice_${currentQuestion.answer}`;
                    let showAnswer = false;
                    let selected = '';
                    const isRevisionMode = isRevisionModeActive(EXAM_NAMES.CFA_3);
                    if (selectedChoice && isRevisionMode) {
                      selected = selectedChoice;
                      showAnswer = true;
                    } else if (answerStatus && isRevisionMode) {
                      if (rightAnswer === 1) {
                        selected = correctAnswer;
                        showAnswer = true;
                      } else if (!rightAnswer) {
                        const choices = ['choice_a', 'choice_b', 'choice_c'].filter(choice => choice !== correctAnswer);
                        selected = choices.length > 0 ? choices[0] : '';
                        showAnswer = true;
                      }
                    }
                    if (showAnswer && isRevisionMode) {
                      this.setState({
                        questions: currentQuestion,
                        selectedChoice: selected,
                        clicked: true,
                        choice_a: selected === 'choice_a' ?
                          (selected === correctAnswer ? 'answer_box success' : 'answer_box failure') :
                          (correctAnswer === 'choice_a' ? 'answer_box success' : 'answer_box'),
                        choice_b: selected === 'choice_b' ?
                          (selected === correctAnswer ? 'answer_box success' : 'answer_box failure') :
                          (correctAnswer === 'choice_b' ? 'answer_box success' : 'answer_box'),
                        choice_c: selected === 'choice_c' ?
                          (selected === correctAnswer ? 'answer_box success' : 'answer_box failure') :
                          (correctAnswer === 'choice_c' ? 'answer_box success' : 'answer_box'),
                        result_block: 'card show_block',
                        text_color: selected === correctAnswer ? 'card-header text_success' : 'card-header text_failure',
                        result: selected === correctAnswer ? 'CORRECT' : 'INCORRECT',
                      });
                    } else {
                      this.setState({
                        questions: currentQuestion,
                        selectedChoice: '',
                        clicked: false,
                        choice_a: 'answer_box',
                        choice_b: 'answer_box',
                        choice_c: 'answer_box',
                        result_block: 'card hide_block',
                      });
                    }
                    this.handleTimerResponse(selected);
                  }
                }

                this.setState({
                  offset: offset_res,
                  all_questions_state: resp_question.questions_details,
                });

                var params_fav = {
                  token: token_id,
                  idname: idname,
                  question_id: questionid,
                  chapter_id: chapterid,
                };

                FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getFavQuestions', params_fav).then(response => {
                  if (response.success) {
                    this.setState({
                      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                      bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                      bookmarkColor: 'rgb(54, 141, 84)',
                      save_text: `${language.LC().Question_Saved}`,
                      isFlashCardHidden: false,
                    });
                  } else {
                    this.setState({ isFlashCardHidden: true });
                  }
                });

                var params = {
                  token: token_id,
                  idname: idname,
                  question_id: questionid,
                };
                FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getCfaratting', params).then(
                  response => {
                    if (response.success) {
                      this.setState({ rated: true });
                      response.ratting.map(items => {
                        this.setState({
                          rating: items.ratting,
                          ratting_text: 'Rated ',
                        });
                      });
                    }
                  },
                );

                var params = {
                  token: token_id,
                  idname: idname,
                  question_id: questionid,
                };
                FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getFlashCards', params).then(
                  response => {
                    var flash_cards = '';
                    if (response.success) {
                      this.setState({ ValidToken: true });
                      if (response.flash_cards.length > 0) {
                        this.setState({
                          flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
                        });
                        flash_cards = response.flash_cards.map((items, index) => (
                          <li key={index}>
                            <div className=''>
                              <ul className='icon_list'>
                                <li>
                                  <a
                                    className='pointer_class'
                                    onClick={this._editFlash.bind(this, items)}
                                  >
                                    <i className='fa fa-pencil' />
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className='pointer_class'
                                    onClick={this._deleteFlash.bind(this, items)}
                                  >
                                    <i className='fa fa-close' />
                                  </a>
                                </li>
                              </ul>
                              <div className={this.state.flash_class}>
                                <h4 />
                                <p>{items.flash_card}</p>
                              </div>
                            </div>
                          </li>
                        ));
                      } else {
                        this.setState({
                          flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                        });
                        flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                      }
                      this.setState({ flash_data: flash_cards });
                    } else {
                      flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                      this.setState({
                        ValidToken: false,
                        flash_data: flash_cards,
                        flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                      });
                    }
                    return response;
                  },
                );

                this.setState({ records: '' });
              }
            }
          },
        );
      } else {
        this.setState({ ValidToken: false, records: 'Result not found.' });
      }
      clearInterval(this.timer);
      this.timer = setInterval(this._tick.bind(this), 1000);
      return resp;
    });
    this.setState({ timer_stop: true, timer_tag: 'Start', count: 0 });
    clearInterval(this.timer);
    this.timer = setInterval(this._tick.bind(this), 1000);
  }

  handleTimerResponse = (selectedChoice) => {
    if (selectedChoice) {
      clearInterval(this.timer);
      this.setState({
        timer_stop: true,
        timer_tag: 'Start',
        timerstopbtn: 'pause_btn icon-control-play',
        count: this.state.questions["cfa3_question_stats.time_done"] || 0
      });
    } else {
      this.setState({
        timer_stop: false,
        timer_tag: 'Stop',
        timerstopbtn: 'pause_btn icon-control-pause',
        count: 0
      });
      clearInterval(this.timer);
      this.timer = setInterval(this._tick.bind(this), 1000);
    }
  };

  _getSubscribe = () => {
    this.context.router.push({
      pathname: '/subscribe/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  render() {
    const { reportLoading, questions, isFlashCardHidden } = this.state;
    let questions_data_display = questions;
    let count_temp_var = this.state.count;
    let display_time = '';
    if (count_temp_var < 60) {
      display_time = count_temp_var + 'sec';
    } else {
      var temp_min = Math.trunc(count_temp_var / 60);
      var temp_sec = Math.trunc(count_temp_var % 60);
      display_time = temp_min + 'min ' + temp_sec + 'sec';
    }
    const choice_a = 'a';
    const choice_b = 'b';
    const choice_c = 'c';
    let forumData = '';

    let data,
      question_data = '';
    forumData = `<div class='col-sm-12 no-cursor'>
    <div class='margin_bottom_40'>
      <div>
        <div class='row'>
          <div class='col-sm-12'>
            <div class='row no-cursor'>
              <div class='col-sm-12 cursor-text'>
                <div
                  contentEditable='false'
                  class='margin_bottom_40 view_questionhtml bg_blue '
                >                      
                  ${questions_data_display.question}
                </div>
              </div>
              <div class='col-sm-12 no-cursor' id='choice_a'>
                <div class='answer_box_forum'>
                  <div class='answer_count'>${language.LC().A}</div>
                  <p class='ans_box_text'>
                    <span contentEditable='false'>                          
                      ${questions_data_display.choice_a}
                    </span>
                  </p>
                </div>
              </div>

              <div class='col-sm-12 no-cursor' id='choice_b'>
                <div class='answer_box_forum'>
                  <div class='answer_count'>${language.LC().B}</div>
                  <p class='ans_box_text'>
                    <span contentEditable='false'>                          
                      ${questions_data_display.choice_b}
                    </span>
                  </p>
                </div>
              </div>
              <div
                class='col-sm-12 margin_bottom_30 no-cursor'
                id='choice_c'
              >
                <div class='answer_box_forum'>
                  <div class='answer_count'>${language.LC().C}</div>
                  <p class='ans_box_text'>
                    <span contentEditable='false'>
                      ${questions_data_display.choice_c}
                    </span>
                  </p>
                </div>
              </div>
              <div class='col-sm-12 cursor-text'>
                <p contentEditable='false' class='view_questionhtml'>
                The correct answer is  ${questions_data_display.answer === 'choice_a'
        ? `<strong> A.</strong>`
        : questions_data_display.answer === 'choice_b'
          ? `<strong> B.</strong>`
          : questions_data_display.answer === 'choice_c'
            ? `<strong> C.</strong>`
            : `<strong> C.</strong>`
      } <br/>
                ${questions_data_display.explanation}
                </p>
              </div>
              <div class='col-sm-12 margin_bottom_30 no-cursor'>
                <div class='userQuestionDiv'>
                  <span class='questionColor cursor-text'>                        
                    *User Question:
                  </span>
                  <div class='forum-data-comment cursor-text'>
                    <h4> ${this.state.forumComment}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>`;
    data = (
      <div className='col-sm-12 col-md-12 note-section note-section-new'>
        <div className='card note-section-header Cfa3-note-section-header ffff'>
          <div className='card-header title-font-size'>
            {this.state.cases_name}
            <div className='float-right text-right'>
              {parseInt(this.state.cases_offset) !== 0 && (
                <i
                  className='fa fa-angle-left ques_arrow pointer_class'
                  onClick={this._getPreviousCase}
                />
              )}
              <i
                className='fa fa-angle-right ques_arrow pointer_class'
                onClick={this._getNextCase}
              />
            </div>
          </div>
          <div className={'card-block note_text_wrap  ' + this.state.display_cases}>
            <div className='px-2'>
            {renderHTMLContent(this.state.cases_display, "span", "", { contentEditable: "false", suppressContentEditableWarning: true })}
            </div>
          </div>
        </div>
      </div>
    );

    {
      this.state.showCompletionQuestion
        ? (question_data = (
          <div className='w-100'>
            <div className={'card-block ' + this.state.display_subcription}>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='card'>
                    <span>{language.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={'col-md-12 complete-section-wrap ' + this.state.display_cases}>
              <div className='card'>
                <div className='card-header text-center'>
                  {/* <img src={App_data.frontend_url+"/img/question_bank/question_icon_blue.svg"} className="margin_right_20" alt="" width="30" /> */}
                  {language.LC().Mark_this_Question_as_Completed}
                  {/* <button onClick = {this._getNextAnyway} > Go To Question 1 </button> */}
                  <div onClick={this._getNextAnyway} className='float-right text-right'>
                    <i className='fa fa-angle-right ques_arrow pointer_class' />
                  </div>
                </div>

                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-12 text-center'>
                      <div className='row'>
                        <div className='col-sm-12 col-md-12 '>
                          <div className='quation-img'>
                            <img
                              src={
                                App_data.frontend_url +
                                '/img/question_bank/question_icon_blue.svg'
                              }
                              className='margin_bottom_10'
                              alt=''
                            />
                          </div>
                          <div
                            contentEditable='false'
                            suppressContentEditableWarning={true}
                            className='margin_bottom_10 view_questionhtml bg_blue'
                          >
                            {' '}
                            {language.LC().MARK_THIS_QUESTION_AS_COMPLETED}{' '}
                          </div>
                        </div>
                        <div className='complete-or-not-wrap'>
                          <div className='check-button-wrap'>
                            <div className='card-actions float-right'>
                              <label className='check_container margin_bottom_0'>
                                {' '}
                                {language.LC().COMPLETED}
                                <input
                                  type='checkbox'
                                  id='mark_completed'
                                  name='mark_completed'
                                  value='select'
                                  onClick={this.markCompleted.bind(this)}
                                  checked={this.state.markAsCompleted}
                                />
                                <span className='checkmark' />
                              </label>
                            </div>
                            <div className='card-actions float-right'>
                              <label className='check_container margin_bottom_0'>
                                {language.LC().NOT_COMPLETED}
                                <input
                                  type='checkbox'
                                  id='mark_not_completed'
                                  name='mark_not_completed'
                                  value='select'
                                  onClick={this.markNotCompleted.bind(this)}
                                  checked={this.state.markAsNotCompleted}
                                />
                                <span className='checkmark' />
                              </label>
                            </div>
                          </div>
                          <div className='d-block text-center complete-quation-submit'>
                            <button
                              disabled={this.state.markCompleted}
                              onClick={this.changeCompletionStatus.bind(this)}
                              className='btn btn-primary pointer_class'
                            >
                              {' '}
                              {language.LC().SUBMIT}{' '}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
        : (question_data = (
          <div className='note-section note-section-new'>
            <div className={'card-block ' + this.state.display_subcription}>
              <div className='row'>
                <div className='col-sm-12 col-md-12'>
                  <div className='card font-lusitana'>
                    <div className='card-header'>
                      <h4>{language.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={'col-sm-12 col-md-12 ' + this.state.display_cases}>
              <div className='card font-lusitana'>
                <div className='card-header'>
                  <img
                    src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
                    className='margin_right_20'
                    alt=''
                    width='30'
                  />
                  {language.LC().QUESTION} {questions_data_display.question_number + ' - '}
                  <div className='float-right text-right'>
                    {this.state.offset !== 0 && (
                      <i
                        className={'fa fa-angle-left ques_arrow pointer_class '}
                        onClick={this._getPrevious}
                      />
                    )}
                    <i
                      className={'fa fa-angle-right ques_arrow pointer_class '}
                      onClick={this._getNext}
                    />
                  </div>
                </div>

                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-9'>
                      <ViewQuestion
                        {...questions_data_display}
                        {...this.props}
                        setAnswer={this._getAnswer}
                        showAnswer={this.state.clicked}
                        correctChoice={`choice_${questions_data_display.answer}`}
                        selectedChoice={this.state.selectedChoice}
                        onValidate={() => this._getResult(questions_data_display)}
                      >
                        <Col md={12} className="mt-2">
                          <Row className="align-items-center">
                            <div className='d-flex align-items-center'>
                              <ValidateSaveReportIcon
                                isQue={true}
                                _getResult={this._getResult}
                                clicked={this.state.clicked}
                                _saveQuestion={this._saveQuestion}
                                _displayReportForm={this._displayReportForm}
                                all_questions={questions_data_display}
                                save_text={this.state.save_text}
                                bookmarkCSS={this.state.bookmarkCSS}
                                bookmarkColor={this.state.bookmarkColor}
                                disabled={!this.state.selectedChoice || this.state.clicked}
                              />
                            </div>
                            <div className='col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right'>
                              <span className='margin_bottom_0 margin_right_10 font-16px'>
                                {this.state.ratting_text}
                              </span>
                              <div className='star_rating_wrap'>
                                <StarRatings
                                  rating={this.state.rating}
                                  starRatedColor='rgb(255, 180, 0)'
                                  starEmptyColor='rgb(51, 51, 51)'
                                  starDimension='20px'
                                  starHoverColor='rgb(255, 180, 0)'
                                  starSpacing='2px'
                                  changeRating={this.onStarClick.bind(this, questions_data_display)}
                                  numberOfStars={5}
                                  name='rate1'
                                />
                              </div>
                            </div>
                          </Row>
                        </Col>
                      </ViewQuestion>
                    </div>
                    <div className='col-sm-3'>
                      <div className='timer_outer'>
                        <i className='fa fa-clock-o' />
                        <span className='timer_box'>{display_time}</span>
                      </div>

                      <button
                        type='button'
                        className={this.state.timerstopbtn}
                        onClick={this.timerFunction.bind(this, questions_data_display)}
                        disabled={!!this.state.selectedChoice || this.state.clicked}
                      >
                        {/*this.state.timer_tag*/}
                      </button>
                      {this.state.subscriptionstatus == 'free' ? (
                        <a
                          onClick={this._getSubscribe}
                          className='box_question_color text-center cursor_pointer'
                        >
                          <p className='margin_bottom_0'>
                            {language.LC().SUBSCRIBE_FOR_3000_PRACTICE_QUESTIONS}
                          </p>
                        </a>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${this.state.result_block} font-lusitana font-16px`}>
                <div className={this.state.text_color}>{this.state.result}</div>
                <div className='card-block'>
                {renderHTMLContent(questions_data_display.explanation, "p", "view_questionhtml", { contentEditable: "false" })}
                </div>
              </div>

              <div className='row'>
                <div className='col-md-12'>
                  <div className={this.state.report_block}>
                    <div className='card-header'>
                      {language.LC().REPORT}
                      {/* <TooltipItem
                      key="1"
                      id="1"
                      content={this.state.tooltips[1].placement}
                      place_tip={this.state.tooltips[1].text_align}
                    /> */}
                    </div>

                    {!this.state.successAlert ? (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-12 col-md-12'>
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong> {language.LC().COMMENT}</strong>
                            </label>
                          </div>
                          <div className='col-sm-12 col-md-12 margin_bottom_10'>
                            <textarea
                              id='comment'
                              name='comment'
                              rows='6'
                              className='form-control'
                              placeholder='Content..'
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-sm-12 col-md-12'>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class report-btn'
                              disabled={reportLoading}
                              onClick={this._reportQuestion.bind(this, questions_data_display)}
                            >
                              {' '}
                              {reportLoading ? language.LC().PLEASE_WAIT : language.LC().REPORT}
                            </button>
                            <button
                              type='button'
                              className='btn btn-danger active pointer_class margin_left_10'
                              onClick={this._hideReportForm.bind(this, questions_data_display)}
                            >
                              {' '}
                              {language.LC().CANCEL}
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-12 report-Success-card'>
                            <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                            </label>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class  min-vw-120'
                              onClick={this.onClose}
                            >
                              {' '}
                              {language.LC().CLOSE}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className='row'>
                <FlashCard
                  item={questions}
                  type='question'
                  isFlashCardHidden={isFlashCardHidden}
                  ref={this.setChildRef}
                  exam='cfa3'
                />
              </div>
            </div>
          </div>
        ));
    }
    return (
      <div className='animated fadeIn'>
        <div className='row note-section note-section-new'>
          <div className='col-sm-8 margin_bottom_20'>
            <h1 className='section_head title-font-size'>
              {language.LC().CASE_STUDY} - {this.state.chaptername}
            </h1>
          </div>
          <div className='col-sm-4 margin_bottom_20 text-sm-right'>
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getReadings}
            >
              {language.LC().CHANGE_CASES}
            </button>
          </div>
        </div>

        <div className='row'>
          {data}
          {question_data}
        </div>

        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
          exam={examNameAccordingToDB.CFA_LEVEL_3}
        />
      </div>
    );
  }
}

class TooltipItem extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          width='18'
          alt=''
          style={{ marginLeft: '4px' }}
        />
        {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id} ></i>*/}

        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}

export default Cfa3chapter;



// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3chapter/Cfa3chapter.js